@if (readOnly()) {
  @let notice = notice$ | async;
  @let copy = tooltipCopy;
  <output
    class="crop-year-selector--readonly"
    [class.crop-year-selector--past-year]="notice?.cropYear != null"
    data-test="crop-year-selector"
    [attr.aria-label]="'cropYearSelector.label' | translate"
    [attr.tabindex]="notice?.cropYear != null ? 0 : null"
    [matTooltip]="
      notice?.cropYear != null
        ? (copy.messageStartKey | translate) +
          (copy.dashboardKey | translate) +
          ('cropYearNotice.messageEnd' | translate)
        : ''
    "
  >
    <span class="crop-year-selector__label">{{ 'cropYearSelector.label' | translate }}</span>
    <span class="crop-year-selector__value">{{ cropYear$ | async }}</span>
    @if (notice?.cropYear != null) {
      <span class="crop-year-selector__notice">{{ 'cropYearNotice.title' | translate }}</span>
    }
  </output>
} @else {
  <mat-form-field appearance="outline" subscriptSizing="dynamic" data-test="crop-year-selector">
    <mat-label>{{ 'cropYearSelector.label' | translate }}</mat-label>
    <mat-select
      [value]="cropYear$ | async"
      [attr.aria-label]="'cropYearSelector.label' | translate"
      (selectionChange)="selectYear($event.value)"
    >
      @for (year of (availableCropYears$ | async) ?? []; track year) {
        <mat-option [value]="year">{{ year }}</mat-option>
      }
    </mat-select>
  </mat-form-field>
}
